<template>
  <div class="flex flex-col items-center justify-between min-h-screen">
    <div>
      <div class="flex flex-col justify-center items-center md:mt-12 md:w-full">
        <!-- <h1 class="text-xl text-center mt-8 text-gray-600">การทำแบบคัดกรองสุขภาพประจำเดือน</h1>
        <h1 class="text-3xl text-center mb-4 text-primary">{{completion.month}}</h1>-->

        <h1 class="text-3xl text-center mt-8 text-gray-600">คำชี้แจงเบื้องต้น</h1>
        <p class="text-base text-center text-gray-500 px-2 md:w-196">
          CMU i-Heath เป็นระบบสารสนเทศในการประเมินสุขภาพเบื้องต้นด้วยตนเอง
          (Self-Evaluation) โดยจะใช้เวลาในการทำแบบประเมินประมาณ 5-10 นาที ประกอบด้วย 3
          ส่วนได้แก่
        </p>
      </div>

      <p v-if="isCompleted" class="text-xl text-center mb-6 mt-16">
        ท่านทำแบบสอบถามครบแล้ว
      </p>
      <p v-else class="text-xl text-center mb-6 mt-16">ท่านยังทำแบบสอบถามไม่ครบ</p>

      <div class="flex flex-col items-center w-full">
        <div class="flex flex-col md:flex-row justify-between md:justify-evenly md:w-256">
          <router-link to="/survey" :disabled="completion.assessments.risk_assessment">
            <button
              class="border-primary border-2 bg-primary rounded px-4 py-2 text-white w-80 h-24 mb-8 relative"
            >
              <p class="mb text-base font-light">แบบคัดกรองความเสี่ยงด้านสุขภาพ</p>

              <p class="font-light capitalize">Health risk assessment</p>

              <svg
                v-show="completion.assessments.risk_assessment"
                class="w-8 h-8 absolute top-0 -ml-8 -mt-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 367.805 367.805"
              >
                <path
                  d="M183.903.001c101.566 0 183.902 82.336 183.902 183.902s-82.336 183.902-183.902 183.902S.001 285.469.001 183.903C-.288 82.625 81.579.29 182.856.001h1.047z"
                  fill="#3bb54a"
                />
                <path
                  fill="#d4e1f4"
                  d="M285.78 133.225L155.168 263.837l-73.143-72.62 29.78-29.257 43.363 42.841 100.833-100.833z"
                />
              </svg>
            </button>
          </router-link>

          <router-link
            to="/assessment-whoqol"
            :disabled="completion.assessments.whoqol_assessment"
          >
            <button
              class="border-primary border-2 bg-primary rounded px-4 py-2 text-white w-80 h-24 mb-8 relative"
            >
              <p class="mb text-base font-light">
                แบบประเมินคุณภาพชีวิตขององค์การอนามัยโลกแบบย่อ
              </p>

              <p class="font-light capitalize">WHOQOL-BREF</p>

              <svg
                v-show="completion.assessments.whoqol_assessment"
                class="w-8 h-8 absolute top-0 -ml-8 -mt-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 367.805 367.805"
              >
                <path
                  d="M183.903.001c101.566 0 183.902 82.336 183.902 183.902s-82.336 183.902-183.902 183.902S.001 285.469.001 183.903C-.288 82.625 81.579.29 182.856.001h1.047z"
                  fill="#3bb54a"
                />
                <path
                  fill="#d4e1f4"
                  d="M285.78 133.225L155.168 263.837l-73.143-72.62 29.78-29.257 43.363 42.841 100.833-100.833z"
                />
              </svg>
            </button>
          </router-link>

          <router-link
            :disabled="completion.assessments.hplp_assessment"
            to="/assessment-hplp"
          >
            <button
              class="border-primary border-2 bg-primary rounded px-4 py-2 text-white w-80 h-24 mb-8 relative"
            >
              <p class="mb text-base font-light">แบบประเมินพฤติกรรมสร้างเสริม สุขภาพ</p>

              <p class="font-light capitalize">
                Health Promotion Lifestyle Profile: Healthy CMU’Version
              </p>

              <svg
                v-show="completion.assessments.hplp_assessment"
                class="w-8 h-8 absolute top-0 -ml-8 -mt-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 367.805 367.805"
              >
                <path
                  d="M183.903.001c101.566 0 183.902 82.336 183.902 183.902s-82.336 183.902-183.902 183.902S.001 285.469.001 183.903C-.288 82.625 81.579.29 182.856.001h1.047z"
                  fill="#3bb54a"
                />
                <path
                  fill="#d4e1f4"
                  d="M285.78 133.225L155.168 263.837l-73.143-72.62 29.78-29.257 43.363 42.841 100.833-100.833z"
                />
              </svg>
            </button>
          </router-link>
        </div>
      </div>

      <div class="flex flex-col items-center justify-center mt-16 mb-8">
        <p class="text-center">
          เขื่อมต่อกับ Line Official Account
          เพื่อติดตามข้อมูลข่าวสารและพบกับฟีเจอร์อีกมากมายในอนาคต
        </p>

        <a @click="loginWithLineId">
          <button
            class="bg-white border border-primary px-4 py-2 rounded mx-4 my-0 w-64 mt-6"
          >
            <p class="text-white text-center text-primary">
              เชื่อมต่อด้วย Line Official Account
            </p>
          </button>
        </a>
      </div>

      <div
        class="flex flex-col md:flex-row justify-center items-center md:w-256 md:mt-12"
      >
        <a href="https://www.cmu.ac.th/">
          <img src="@/assets/cmu-logo.png" alt class="w-32 h-32 mb-8 md:mx-16" />
        </a>

        <a href="https://healthycmu.com/">
          <img
            src="@/assets/healthy-university-logo.jpg"
            class="w-48 h-48 mb-12 md:mx-16"
          />
        </a>

        <a href="https://healthycmu.com/">
          <img src="@/assets/stay-home-logo.jpg" class="w-48 h-48 mb-12 md:mx-16" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { notification } from "ant-design-vue";
import axios from "axios";
import liff from "@line/liff";

export default {
  async created() {
    this.fetchCompletion();
  },
  data() {
    return {
      completion: {},
    };
  },
  methods: {
    async fetchCompletion() {
      const response = await axios({
        method: "GET",
        url: `${process.env.VUE_APP_API_URL}/me/monthly-completion/check`,
        headers: { authorization: `Bearer ${localStorage.getItem("TOKEN")}` },
      });

      this.completion = response.data;
    },
    async loginWithLineId() {
      try {
        if (!liff.isInClient()) {
          liff.login({
            redirectUri: `${process.env.VUE_APP_URL}/assessments`,
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  computed: {
    isCompleted() {
      if (Object.keys(this.completion).length === 0) {
        return false;
      }

      return Object.values(this.completion.assessments).every((completed) => completed);
    },
  },
};
</script>
